// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vdDDM{border-top:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;background-color:#fff}@media screen and (min-width:768px){.vdDDM{display:flex;justify-content:space-between;border:0;margin:24px 0 40px;background-color:transparent}}.q7ukU{overflow-x:auto}@media screen and (min-width:768px){.JIcko{position:relative;height:32px;flex-shrink:0}.O5OTi{position:absolute;z-index:1;top:-16px;right:40px;min-width:272px;padding:16px 16px 0;background-color:#fff;border-radius:4px;box-shadow:0 0 16px rgba(0,0,0,.08)}}[data-a11y] .vdDDM{margin:48px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articleAuthors": "vdDDM",
	"container": "q7ukU",
	"more": "JIcko",
	"tooltip": "O5OTi"
};
module.exports = ___CSS_LOADER_EXPORT___;
